export default __webpack_public_path__ + "static/media/contents_main.890d5e31.png";